import PropTypes from "prop-types";
// @mui
import { Chip, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
// theme

// ----------------------------------------------------------------------

export default function ProfileCover({
  name,
  avatarUrl,
  role,
  coverUrl,
  enrolled,
}) {
  const theme = useTheme();

  return (
    <Box>
      <Stack
        direction={{ xs: "column", md: "row" }}
        sx={{
          p: 1,
          mt: 3,
          left: { md: 24 },
          zIndex: { md: 10 },
          position: { md: "absolute" },
        }}
        alignItems="center"
      >
        <Avatar
          src={avatarUrl}
          alt={name}
          sx={{
            mx: "auto",
            width: { xs: 54, md: 90 },
            height: { xs: 54, md: 90 },
            border: `solid 2px ${theme.palette.common.white}`,
          }}
        />
        <Stack spacing={1} display="flex" direction="column" sx={{ p: 3 }}>
          <Typography variant="h4"> {name}</Typography>
          <Chip
            color="primary"
            label={
              <Typography variant="caption">
                Courses enrolled: {enrolled}
              </Typography>
            }
            variant="filled"
          />
        </Stack>
      </Stack>
    </Box>
  );
}

ProfileCover.propTypes = {
  avatarUrl: PropTypes.string,
  coverUrl: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
};
